import $ from "jquery";
import MicroModal from "micromodal";
export const microModal = {
    init: () => {
        MicroModal.init({
            onShow: (modal) => {
                modal.removeAttribute("aria-hidden");
                $(`#${modal.id}`).removeClass("!u-hidden");
            },
            onClose: (modal) => {
                modal.removeAttribute("aria-hidden");
                $(`#${modal.id}`).addClass("!u-hidden");
            },
            disableScroll: true,
        });
    },
};
export const simpleModal = {
    init: () => {
        simpleModal.enableGlobal();
        $("[data-modal-target]").each(function () {
            const $thisElement = $(this);
            $thisElement.on("click", function () {
                const modalTargetId = $thisElement.data("modal-target");
                const modalTargetElement = $("#" + modalTargetId);
                const modalAction = $thisElement.data("modal-action");
                const hasHiddenClass = modalTargetElement.hasClass("!u-hidden");
                const hasBodyHiddenScroll = $("body").hasClass("u-overflow-hidden");
                const shouldHideModal = modalAction === "hide";
                const shouldShowModal = modalAction === "show";
                if (shouldHideModal && !hasHiddenClass) {
                    modalTargetElement.addClass("!u-hidden");
                    if (hasBodyHiddenScroll) {
                        $("body").removeClass("u-overflow-hidden");
                    }
                }
                if (shouldShowModal && hasHiddenClass) {
                    modalTargetElement.removeClass("!u-hidden");
                    if (!hasBodyHiddenScroll) {
                        $("body").addClass("u-overflow-hidden");
                    }
                }
            });
        });
    },
    enableGlobal: () => {
        if (!window["simpleModal"]) {
            window["simpleModal"] = simpleModal;
        }
    },
};
